import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as signalR from '@microsoft/signalr';
import { MessageTemplate } from '../../models/enums/enums';
@Injectable({
  providedIn: 'root'
})
export class SignalRService {

  constructor() { }

  connection!: signalR.HubConnection;

  hubNotification: Subject<{ messageTemplate: MessageTemplate;message:string; data: any }>
  = new Subject<{ messageTemplate: MessageTemplate;message:string; data: any }>();

   // Establish a connection to the SignalR server hub
   public initiateSignalrConnection(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(environment.apis.default.baseUrl + environment.apis.default.signalrNotificationHubUrl,
          {
            accessTokenFactory: () => {
              const account = localStorage.getItem('account');
              return account ? JSON.parse(account).token : '';
            },
          }
        )
        .build();

      this.setSignalrClientMethods();

      this.connection
        .start()
        .then(() => {
          resolve();
        })
        .catch((error: any) => {
          reject();
        });
    });
  }

  private mapTemplateKeyToEnum(templateKey: string): MessageTemplate | undefined {
    const map: { [key: string]: MessageTemplate } = {
      'TASK_ASSIGNED': MessageTemplate.TaskAssigned,
      'TASK_COMPLETED': MessageTemplate.TaskCompleted,
      'ESSAY_SUBMISSION': MessageTemplate.EssaySubmission,
      'RECOMMENDATION_SUBMISSION': MessageTemplate.RecommendationSubmission,
      'ACTIVITY_SUBMISSION': MessageTemplate.ActivitySubmission,
      'MENTOR_REVIEW': MessageTemplate.MentorReview,
      'MEETING_SCHEDULED': MessageTemplate.MeetingScheduled,
      'MEETING_CANCELED': MessageTemplate.MeetingCanceled,
      'MEETING_RESCHEDULED': MessageTemplate.MeetingRescheduled,
      'ADDED_MY_INSTITUTE': MessageTemplate.AddedMyInstitute,
      'MINDLER_NOTIFICATION': MessageTemplate.MindlerNotification,
      'DOCUMENT_REQUESTED': MessageTemplate.DocumentRequested,
      'DOCUMENT_UPLOADED': MessageTemplate.DocumentUploaded
    };
    return map[templateKey];
  }

  // This method will implement the methods defined in the ISignalrDemoHub interface in the SignalrDemo.Server .NET solution
  private setSignalrClientMethods(): void {
    this.connection.on('ReceiveNotification', (templateKey: string, message: string, data: any) => {
      // console.log('Received SignalR event:', { templateKey, message, data });
      const messageTemplate = this.mapTemplateKeyToEnum(templateKey);
      
      if (messageTemplate !== undefined) {
        this.hubNotification.next({
          messageTemplate: messageTemplate,
          message: message, 
          data: data
        });
      } else {
        console.warn('Unknown message template received from SignalR:', templateKey);
      }
    });
  }
}
